import React, { useEffect, useMemo, useState, useRef } from "react";
import Particles, { initParticlesEngine } from "@tsparticles/react";
import { loadFull } from "tsparticles";
import { IOptions, RecursivePartial } from "@tsparticles/engine";

export default function SuccessParticles() {
  const [init, setInit] = useState(false);
  const [delay, setDelay] = useState(0.05); // start fast
  const delayRef = useRef(delay);
  delayRef.current = delay;

  useEffect(() => {
    initParticlesEngine(async (engine) => {
      await loadFull(engine).catch((err) => {
        console.error("Error loading tsparticles:", err);
      });
    })
      .then(() => {

        setInit(true);

      })
      .catch((err) => {
        console.error("Error loading tsparticles:", err);
      });
  }, []);

  // Slow down emission every second by increasing delay
  useEffect(() => {
  const interval = setInterval(() => {

    setDelay((prev) => {
      const next = Math.min(prev + 0, 1);

      return next;
    });

  }, 1000);

  return () => clearInterval(interval);
}, []);


  const options = useMemo<RecursivePartial<IOptions>>(() => ({
    fullScreen: { enable: true, zIndex: 9999 },
    particles: {
      number: { value: 20 },
      move: {
        enable: true,
        speed: { min: 1, max: 3 },
        direction: "top",
        angle: { value: 90, offset: 45 },
        outModes: { default: "destroy" },
      },
      shape: {
        type: "image",
        options: {
          image: [
            { src: "/assets/backpack.png", width: 32, height: 32 },
            { src: "/assets/baloon.png", width: 32, height: 32 },
            { src: "/assets/boardingPass.png", width: 32, height: 32 },
            { src: "/assets/earthGlobe.png", width: 32, height: 32 },
            { src: "/assets/forest.png", width: 32, height: 32 },
            { src: "/assets/sunLounger.png", width: 32, height: 32 },
          ],
        },
      },
      size: { value: { min: 10, max: 30 } },
      opacity: {
        value: 0.8,
        animation: { enable: true, startValue: "max", count: 1, speed: 0.3, decay: 0.1, sync: false },
      },
    },
    detectRetina: true,
    gravity: { enable: true, acceleration: 1, inverse: false },
    emitters: {
      life: { count: 0 }, // infinite
      rate: {
        delay: delayRef.current, // dynamically updated delay
        quantity: 5,
      },
      direction: "top",
      size: { width: 0, height: 0 },
      position: { x: 50, y: 120 },
    },
  }), [delay]);

  if (init) {
    return <Particles id="tsparticles" options={options} />;
  }

  return null;
}
